import {fromJS} from "immutable";
import {
  LOAD_WATER_PALLETS,
  LOAD_WAREHOUSES,
  LOAD_WAREHOUSE,
  LOAD_PRODUCTS,
  LOAD_PRODUCT,
  LOAD_STOCK_ITEMS,
  LOAD_STOCK_ITEM,
  RENAME_WAREHOUSE,
  CHANGE_WAREHOUSE_CONTACT,
  CHANGE_WAREHOUSE_ADDRESS,
  REGISTER_WAREHOUSE,
  RECORD_WATER_TEST_RESULT,
  CREATE_PRODUCT,
  ADD_PRODUCT_VARIATION,
  ADD_PRODUCT_SIZE,
  REMOVE_PRODUCT,
  REMOVED_PRODUCT,
  CREATE_PRODUCT_CONFIGURATION,
  HANDLE_INCOMING_EVENT,
  SET_STOCK_WAREHOUSE_FILTER,
} from "../actions/InventoryApiActions";
import {
  setSubmitStatus,
  getEntity,
  getEntityCollection,
  setEntityCollection,
  removeEntity
} from "./helpers";

export {
  getSubmitInfoForCommand
} from "./helpers";

export const WATER_PRODUCT_TYPE = "WAT";
export const DISPENSER_PRODUCT_TYPE = "DPR";

const initialState = fromJS({
  cmdSubmission: {},
  entities: {},
  ids: {},
  productTypes: [
    { type: WATER_PRODUCT_TYPE, title: "Water"},
    { type: DISPENSER_PRODUCT_TYPE, title: "Dispenser" }
  ],
  warehouseFilter: ""
})

const reducer = function(state = initialState, action) {
  switch(action.type) {

    case LOAD_PRODUCTS.SUCCESS:
      return setEntityCollection(state, "products", action.entities.products, action.result.products);    
    case LOAD_PRODUCT.SUCCESS:
      return addToIds(
        state.setIn(["entities", "products", action.result], fromJS(action.entities.products[action.result])),
        "products",
        action.result
        );
    case LOAD_STOCK_ITEMS.SUCCESS:
      return setEntityCollection(state, "stock_items", action.entities.stock_items, action.result.stock_items);
    case LOAD_STOCK_ITEM.SUCCESS:
      return addToIds(
        state.setIn(["entities", "stock_items", action.result], fromJS(action.entities.stock_items[action.result])),
        "stock_items",
        action.result
        );
    case LOAD_WAREHOUSES.SUCCESS:
      return setEntityCollection(state, "warehouses", action.entities.warehouses, action.result.warehouses);
    case LOAD_WATER_PALLETS.SUCCESS:
      return setEntityCollection(state, "water_pallets", action.entities.water_pallets, action.result.water_pallets);
    case LOAD_WAREHOUSE.SUCCESS:
      return state.setIn(["entities", "warehouses", action.result], fromJS(action.entities.warehouses[action.result]));

    case REMOVED_PRODUCT:
      return removeEntity(state, "products", action.code);

    case RENAME_WAREHOUSE.SUBMIT:
      return setSubmitStatus(state, "RenameWarehouse", "submitting");
    case RENAME_WAREHOUSE.FAILED:
      return setSubmitStatus(state, "RenameWarehouse", "failed", action.error);
    case RENAME_WAREHOUSE.SUCCESS:
      return setSubmitStatus(state, "RenameWarehouse", "");

    case CHANGE_WAREHOUSE_CONTACT.SUBMIT:
      return setSubmitStatus(state, "ChangeWarehouseContact", "submitting");
    case CHANGE_WAREHOUSE_CONTACT.FAILED:
      return setSubmitStatus(state, "ChangeWarehouseContact", "failed", action.error);
    case CHANGE_WAREHOUSE_CONTACT.SUCCESS:
      return setSubmitStatus(state, "ChangeWarehouseContact", "");

    case CHANGE_WAREHOUSE_ADDRESS.SUBMIT:
      return setSubmitStatus(state, "ChangeWarehouseAddress", "submitting");
    case CHANGE_WAREHOUSE_ADDRESS.FAILED:
      return setSubmitStatus(state, "ChangeWarehouseAddress", "failed", action.error);
    case CHANGE_WAREHOUSE_ADDRESS.SUCCESS:
      return setSubmitStatus(state, "ChangeWarehouseAddress", "");

    case REGISTER_WAREHOUSE.SUBMIT:
      return setSubmitStatus(state, "RegisterWarehouse", "submitting");
    case REGISTER_WAREHOUSE.FAILED:
      return setSubmitStatus(state, "RegisterWarehouse", "failed", action.error);
    case REGISTER_WAREHOUSE.SUCCESS:
      return setSubmitStatus(state, "RegisterWarehouse", "");

    case RECORD_WATER_TEST_RESULT.SUBMIT:
      return setSubmitStatus(state, "RecordWaterTestResult", "submitting");
    case RECORD_WATER_TEST_RESULT.FAILED:
      return setSubmitStatus(state, "RecordWaterTestResult", "failed");
    case RECORD_WATER_TEST_RESULT.SUCCESS:
      return setSubmitStatus(state, "RecordWaterTestResult", "");

    case CREATE_PRODUCT.SUBMIT:
      return setSubmitStatus(state, "CreateProduct", "submitting");
    case CREATE_PRODUCT.FAILED:
      return setSubmitStatus(state, "CreateProduct", "failed", action.error);
    case CREATE_PRODUCT.SUCCESS:
      return setSubmitStatus(state, "CreateProduct", "");

    case ADD_PRODUCT_SIZE.SUBMIT:
      return setSubmitStatus(state, "AddProductSize", "submitting");
    case ADD_PRODUCT_SIZE.FAILED:
      return setSubmitStatus(state, "AddProductSize", "failed");
    case ADD_PRODUCT_SIZE.SUCCESS:
      return setSubmitStatus(state, "AddProductSize", "");

    case ADD_PRODUCT_VARIATION.SUBMIT:
      return setSubmitStatus(state, "AddProductVariation", "submitting");
    case ADD_PRODUCT_VARIATION.FAILED:
      return setSubmitStatus(state, "AddProductVariation", "failed");
    case ADD_PRODUCT_VARIATION.SUCCESS:
      return setSubmitStatus(state, "AddProductVariation", "");

    case CREATE_PRODUCT_CONFIGURATION.SUBMIT:
      return setSubmitStatus(state, "CreateProductConfiguration", "submitting");
    case CREATE_PRODUCT_CONFIGURATION.FAILED:
      return setSubmitStatus(state, "CreateProductConfiguration", "failed");
    case CREATE_PRODUCT_CONFIGURATION.SUCCESS:
      return setSubmitStatus(state, "CreateProductConfiguration", "");

    case REMOVE_PRODUCT.SUBMIT:
      return setSubmitStatus(state, "RemoveProduct", "submitting");
    case REMOVE_PRODUCT.FAILED:
      return setSubmitStatus(state, "RemoveProduct", "failed");
    case REMOVE_PRODUCT.SUCCESS:
      return setSubmitStatus(state, "RemoveProduct", "");


    case HANDLE_INCOMING_EVENT:
      return handleIncomingEvent(state, action.event, action.payload);

    case SET_STOCK_WAREHOUSE_FILTER:
      return state.set("warehouseFilter", action.filter);

    default:
      return state;
  }
}

function handleIncomingEvent(state, event, payload) {
  switch(event) {
    case "WaterPalletUpdated":
      return state.mergeIn(["entities", "water_pallets", payload.pallet_id], fromJS(payload));

    default:
      return state;
  }
}

function addToIds(state, entityName, id) {
  const ids = state.getIn(["ids", entityName]);
  if (ids.includes(id)) return state;
  return state.setIn(["ids", entityName], ids.push(id));
}


// Return a list of water pallets.
export function getWaterPallets(state) {
  return getEntityCollection(state, "water_pallets");
}

// Return water pallet.
export function getWaterPalletWithId(state, id) {
  return getEntity(state, "water_pallets", id);
}

// Return a list of warehouses.
export function getWarehouses(state) {
  return getEntityCollection(state, "warehouses");
}

// Return warehouse.
export function getWarehouseWithId(state, id) {
  return getEntity(state, "warehouses", id);
}

// Return a list of products.
export function getProducts(state) {
  return getEntityCollection(state, "products");
}

// Return product.
export function getProductWithId(state, id) {
  return getEntity(state, "products", id);
}

// Return a list of stock_items.
export function getStockItems(state) {
  return getEntityCollection(state, "stock_items");
}

// Return stock item.
export function getStockItemWithId(state, sku) {
  return getEntity(state, "stock_items", sku);
}


// Get the stock warehouse filter.
export function getStockWarehouseFilter(state) {
  return state.get("warehouseFilter");
}

// Get list of product type.
export function getProductTypes(state) {
  return state.get("productTypes");
}

export default reducer;